import type { ReactNode } from "react";

export function PageHeader({
  title,
  sub,
  tone = "gold",
  leading,
}: {
  title: ReactNode;
  sub?: ReactNode;
  tone?: "gold" | "peach" | "green" | "purple";
  leading?: ReactNode;
}) {
  return (
    <header className={`page-header page-header--${tone}`}>
      <div className="page-header__flags" aria-hidden="true">
        <span>🇨🇦</span><span>🇲🇽</span><span>🇺🇸</span>
      </div>
      <HeaderSparkles />
      <div className="page-header__title-row">
        {leading && <span className="page-header__leading">{leading}</span>}
        <div className="page-title">{title}</div>
      </div>
      {sub && <div className="page-sub">{sub}</div>}
    </header>
  );
}

function HeaderSparkles() {
  return (
    <svg className="page-header__sparkles" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M13 2.5c.8 5.8 3.2 8.2 9 9-5.8.8-8.2 3.2-9 9-.8-5.8-3.2-8.2-9-9 5.8-.8 8.2-3.2 9-9Z" />
      <path d="M24 17c.4 3 1.7 4.3 4.7 4.7-3 .4-4.3 1.7-4.7 4.7-.4-3-1.7-4.3-4.7-4.7 3-.4 4.3-1.7 4.7-4.7Z" />
      <circle cx="7" cy="25" r="2" />
    </svg>
  );
}
